<template>
    <div>
        <ValidationObserver ref="updateForm">
        <div class="row data-form">

            <div class="col-12">
                <div class="mb-4">
                    <h6 class="text-uppercase mb-0">{{poolName}}</h6>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <ValidationProvider name="courseSearch" rules="" v-slot="{valid, errors}">
                    <b-form-group :label="$t('course')">
                        <b-form-input
                            @input="tableSearch"
                            v-model="searchResult" />
                    </b-form-group>
                </ValidationProvider>
            </div>
            <div class="col-12 col-md-12">
                <b-table striped hover :items="courseItems" :fields="fields">
                </b-table>
            </div>

        </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import ElectiveCourseService from '@/services/ElectiveCourseService';
    import qs from 'qs';
    import CourseAutoComplete from '@/components/interactive-fields/CourseAutoComplete';

    export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        id: {
            default: null,
            type: Number
        }
    },
    data() {
        return {
            poolName: null,
            searchResult: null,

            fields: [
                {
                    key: 'code',
                    label: this.$t('course_code')
                },
                {
                    key: 'name',
                    label: this.$t('course_name')
                },
                {
                    key: 'language',
                    label: this.$t('course_language')
                },
                {
                    key: 'theoretical_credit',
                    label: this.$t('theoretical_credit')
                },
                {
                    key: 'practical_credit',
                    label: this.$t('practical_credit')
                },
                {
                    key: 'credit',
                    label: this.$t('credit')
                },
                {
                    key: 'ects_credit',
                    label: this.$t('ects_credit')
                }
            ],
            courseItems: [],
            courseItemsTemp: [],
        }
    },
    metaInfo() {
        return {
            title: this.$t("elective_pools_title")
        }
    },
    methods: {
        getFormData() {
            if(this.id != null){
                let config = {
                    params: {
                        filter: {
                            pool_id: this.id
                        },
                        limit: -1
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                ElectiveCourseService.findCourses(config).then(response => {
                    let data = response.data.data
                    this.poolName = data.length > 0 ? data[0].pool.name : ''
                    this.courseItems = []

                    data.forEach(item => {
                        this.courseItems.push({
                            code: item.course.code,
                            name: this.getLocaleText(item.course,"name"),
                            language: item.course.language,
                            theoretical_credit: item.course.theoretical_credit,
                            practical_credit: item.course.practical_credit,
                            credit: item.course.credit,
                            ects_credit: item.course.ects_credit,
                            id: item.course_id
                        })
                    })
                    this.courseItemsTemp = this.courseItems
                })
            }
        },

        tableSearch(search) {
            let searchLower = search.toLowerCase()
            this.courseItems = this.courseItemsTemp
            if(searchLower.length > 0){
                this.courseItems = this.courseItems.filter(item => item.name.toLowerCase().indexOf(searchLower) > -1 || item.code.toLowerCase().indexOf(searchLower) > -1)
            } else {
                this.courseItems = this.courseItemsTemp
            }

        }
    },


    watch: {
        id: {
            handler: function (val) {
                this.getFormData(val)
            }
        }
    }
};
</script>
